import React from 'react';
import claimerMessagesService from '../../services/claim/claimer_messages.service';
import ClaimerMessage from './ClaimerMessage';
export default function ClaimerMessages(_ref) {
  let {
    claimerMessages
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, claimerMessages.map(message => /*#__PURE__*/React.createElement(ClaimerMessage, {
    message: message
  })));
}